// extracted by mini-css-extract-plugin
export default {"card":"Card_card__A60ac","title":"Card_title__ry-3r","icon":"Card_icon__0Lov1"};